import React from 'react'

const Social = () => {
    return (
        <div className='home_social'>
            <a href="https://www.linkedin.com/in/sourav-barik/" className='home_social-icon' target='_blank'>
                <i class="uil uil-linkedin"></i>
            </a>

            <a href="https://github.com/sourav-barik01" className='home_social-icon' target='_blank'>
                <i class="uil uil-github"></i>
            </a>
        </div>
    )
}

export default Social